import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VerifyUserGQL } from './verify-user.graphql';

@Component({
  selector: 'app-verify-user',
  templateUrl: './verify-user.component.html',
  styleUrls: ['./verify-user.component.scss']
})
export class VerifyUserComponent implements OnInit {
  verifyToken: string;
  loader: boolean;
  success: boolean;

  constructor(
    private route: ActivatedRoute, 
    private verifyUserGQL: VerifyUserGQL) {
    this.verifyToken = this.route.snapshot.queryParamMap.get('token');
  }

  ngOnInit(): void {
    this.verifyRegisteration();
  }

  verifyRegisteration() {
    this.loader = true;
    this.verifyUserGQL
    .mutate({
      token: this.verifyToken
    }).subscribe(({data}) => {
      if (data.validateClient.success) {
        this.success = true;
      }
      this.loader = false;
    }, err => {
      this.loader = false;
      this.success = false;
    });
  }

}
